import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DevicePhotoService {

  photoURL: string;

  // tslint:disable-next-line:no-empty
  constructor() { }

  public setPhotoURL(photoURL) {
    return new Observable<boolean>(
      (observable) => {
        this.photoURL = photoURL;
        observable.next(true);
      }
    );
  }
  public getPhotoURL() {
    return new Observable<string>(
      (observable) => {
        observable.next(this.photoURL); }
    );
  }

}
